import { render, staticRenderFns } from "./productoCard.vue?vue&type=template&id=0bffbcc6&scoped=true"
import script from "./productoCard.vue?vue&type=script&lang=js"
export * from "./productoCard.vue?vue&type=script&lang=js"
import style0 from "./productoCard.vue?vue&type=style&index=0&id=0bffbcc6&prod&scoped=true&lang=css"
import style1 from "./productoCard.vue?vue&type=style&index=1&id=0bffbcc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffbcc6",
  null
  
)

export default component.exports